<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <vue-excel-xlsx
          :data="membres"
          :columns="columnMembres"
          :filename="'membres'"
          :sheetname="'membres'"
        >
          <v-btn class="primary">
            <v-icon>mdi-microsoft-excel</v-icon> Télécharger</v-btn
          >
        </vue-excel-xlsx>
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">
                Nom
              </th>
              <th class="text-left">
                Groupe
              </th>
              <th class="text-left">
                Animateur
              </th>
              <th class="text-left">
                Région
              </th>
              <th class="text-left">
                District
              </th>
              <th class="text-left">
                Commune
              </th>
              <th class="text-left">
                Fokontany
              </th>
              <th class="text-left">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(membre, indexMembre) in membres" :key="indexMembre">
              <td>{{ membre.nom }}</td>
              <td>{{ membre.nom_groupe }}</td>
              <td>{{ membre.nom_responsable }}</td>
              <td>{{ membre.ll_region }}</td>
              <td>{{ membre.ll_district }}</td>
              <td>{{ membre.ll_commune }}</td>
              <td>{{ membre.ll_fokontany }}</td>
              <td>
                <v-btn outlined x-small fab dark class="success">
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.GetArrayRegions(this.user);
    this.getmembresDeRegions(this.regionSupervisees);
  },
  data() {
    return {
      columnMembres: [
        {
          label: "Nom",
          field: "nom",
        },
        {
          label: "Groupe",
          field: "nom_groupe",
        },
        {
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          label: "Région",
          field: "ll_region",
        },
        {
          label: "District",
          field: "ll_district",
        },
        {
          label: "Commune",
          field: "ll_commune",
        },
        {
          label: "Fokontany",
          field: "ll_fokontany",
        },
      ],
    };
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    ...mapActions({
      GetArrayRegions: "Utils/GetArrayRegions",
      getmembresDeRegions: "Membres/getmembresDeRegions",
    }),
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      membres: (state) => state.Membres.MembresDesRegions,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
